// Content v3 interface copy (05_Web_and_app_copy, 06_FAQ) mapped onto existing keys — see memory/product/content1/copy_mapping.md
const en = {
 "landing": {
  "sub": "Courses, practical assignments and a structured approach to coat care and grooming preparation. Learn the reasoning, apply feasible steps and document what actually happened."
 },
 "b5": {
  "explore_demo": "Explore demo — no registration",
  "exit_demo": "Exit demo"
 },
 "b6": {
  "video_soon": "Introduction — video coming soon",
  "description": "Professional learning and grooming records. Veterinary diagnosis and treatment are outside the platform’s scope."
 },
 "l": {
  "sub": "Start with the decision process, then choose the course relevant to your work. Each pathway includes lessons, a knowledge check and a reviewed practical assignment. Course information is available before access."
 },
 "b3": {
  "cases_sub": "Cases describe recorded observations, decisions and limitations. Illustrative examples are labelled and are not evidence of real outcomes. Publication requires separate permission."
 },
 "cat": {
  "public_sub": "Compare product functions, label instructions and limitations. Practitioner guidance is shown separately from manufacturer information. Alternatives are possible functional options, not claims of identical composition or therapeutic effect."
 },
 "practice": {
  "sub": "Use observations to choose a feasible task, record the visit and review the owner’s follow-up. Keep unknown information visible."
 },
 "sandbox": {
  "banner": "DEMO — fictional records. Changes here do not affect real clients.",
  "reset": "Reset demo"
 },
 "err": {
  "access_required": "This area needs access. You can still explore the public information and web demo. Contact support if you expected access."
 },
 "help": {
  "sub": "For an account or technical issue, include the screen name, approximate time and what you expected. Do not send passwords or unnecessary client information. For a dog’s health concern, contact a veterinarian rather than platform support.",
  "email_tbc": "Support contact is being configured. This preview is not accepting real client enquiries.",
  "faq_title": "Frequently asked questions",
  "faq": [
   {
    "id": "FAQ-1",
    "q": "Who is the learning for?",
    "a": "Groomers and supervised trainees. It does not replace hands-on training in tools and handling."
   },
   {
    "id": "FAQ-2",
    "q": "Can I see the platform before registering?",
    "a": "Use the public web demo. Its cases are fictional and isolated from real records."
   },
   {
    "id": "FAQ-3",
    "q": "Does this method guarantee a calm first visit?",
    "a": "No. Goals and progression depend on the individual dog and conditions."
   },
   {
    "id": "FAQ-4",
    "q": "Does it treat alopecia?",
    "a": "No. Unexplained hair loss needs veterinary assessment. Grooming care may be organised within the resulting restrictions."
   },
   {
    "id": "FAQ-5",
    "q": "Must every dog complete all four pathways?",
    "a": "No. Choose only relevant pathways and a feasible task."
   },
   {
    "id": "FAQ-6",
    "q": "Are the named products mandatory?",
    "a": "No. The system is based on task suitability and current label instructions, not a mandatory brand."
   },
   {
    "id": "FAQ-7",
    "q": "Are alternatives interchangeable?",
    "a": "No. Similar functions do not establish identical formulas, dilution, safety or therapeutic effects."
   },
   {
    "id": "FAQ-8",
    "q": "Is stopping a failed visit?",
    "a": "Not necessarily. A justified stop may be the appropriate professional decision."
   },
   {
    "id": "FAQ-9",
    "q": "Does a certificate make me a veterinarian?",
    "a": "No. It describes only the completed course and assessment."
   },
   {
    "id": "FAQ-10",
    "q": "Can owners use the full practitioner protocol?",
    "a": "Owners should follow only individually assigned, demonstrated home steps."
   },
   {
    "id": "FAQ-11",
    "q": "Can I use the system for cats?",
    "a": "This edition covers dogs. A cat-specific programme requires separate development."
   },
   {
    "id": "FAQ-12",
    "q": "Are public cases proof that the method caused improvement?",
    "a": "Case observations alone do not establish causation; other changes and missing information must be reported."
   }
  ]
 },
 "b4": {
  "legal": "Draft — not approved for public launch"
 }
};

const ru = {
 "landing": {
  "sub": "Курсы, практические задания и последовательный подход к уходу за шерстью и подготовке к процедурам. Осваивайте логику решений, выполняйте допустимые шаги и фиксируйте реальный результат."
 },
 "b5": {
  "explore_demo": "Открыть демо — без регистрации",
  "exit_demo": "Выйти из демо"
 },
 "b6": {
  "video_soon": "Знакомство с платформой — видео скоро появится",
  "description": "Профессиональное обучение и записи груминга. Ветеринарная диагностика и лечение не входят в назначение платформы."
 },
 "l": {
  "sub": "Начните с логики решений, затем выберите подходящий курс. Каждый маршрут включает уроки, проверку знаний и практическое задание с оценкой. Описание курса доступно до получения доступа."
 },
 "b3": {
  "cases_sub": "Случаи показывают записанные наблюдения, решения и ограничения. Учебные примеры отмечены и не являются доказательствами реальных результатов. Публикация требует отдельного разрешения."
 },
 "cat": {
  "public_sub": "Сравнивайте функции, инструкции и ограничения. Рекомендации специалиста отделены от информации производителя. Альтернативы — возможные варианты по функции, а не заявление об одинаковом составе или лечебном действии."
 },
 "practice": {
  "sub": "Выбирайте выполнимую задачу по наблюдениям, записывайте визит и проверяйте обратную связь владельца. Сохраняйте неизвестные данные явно."
 },
 "sandbox": {
  "banner": "ДЕМО — вымышленные записи. Изменения здесь не затрагивают реальных клиентов.",
  "reset": "Сбросить демо"
 },
 "err": {
  "access_required": "Для этого раздела нужен доступ. Публичная информация и веб-демо остаются доступны. Если вы ожидали доступ, обратитесь в поддержку."
 },
 "help": {
  "sub": "Для технического вопроса укажите экран, примерное время и ожидаемое действие. Не отправляйте пароли и лишние клиентские данные. По вопросам здоровья собаки обращайтесь к ветеринару, а не в поддержку платформы.",
  "email_tbc": "Контакт поддержки настраивается. Предпросмотр не принимает реальные клиентские обращения.",
  "faq_title": "Частые вопросы",
  "faq": [
   {
    "id": "FAQ-1",
    "q": "Для кого обучение?",
    "a": "Для грумеров и учащихся под наблюдением. Оно не заменяет практическое освоение инструментов и обращения."
   },
   {
    "id": "FAQ-2",
    "q": "Можно посмотреть до регистрации?",
    "a": "Используйте публичное веб-демо. Его случаи вымышлены и отделены от реальных записей."
   },
   {
    "id": "FAQ-3",
    "q": "Гарантирует ли метод спокойный первый визит?",
    "a": "Нет. Цели и переходы зависят от конкретной собаки и условий."
   },
   {
    "id": "FAQ-4",
    "q": "Лечит ли система алопецию?",
    "a": "Нет. Необъяснимое выпадение требует ветеринарной оценки. Уход организуется в пределах полученных ограничений."
   },
   {
    "id": "FAQ-5",
    "q": "Каждой собаке нужны все четыре направления?",
    "a": "Нет. Выбирают актуальные направления и выполнимую задачу."
   },
   {
    "id": "FAQ-6",
    "q": "Обязательны ли указанные бренды?",
    "a": "Нет. Основа — соответствие задаче и актуальная инструкция, а не обязательный бренд."
   },
   {
    "id": "FAQ-7",
    "q": "Альтернативы взаимозаменяемы?",
    "a": "Нет. Похожие функции не означают одинаковый состав, разведение, безопасность или лечебный эффект."
   },
   {
    "id": "FAQ-8",
    "q": "Остановка означает неудачный визит?",
    "a": "Не обязательно. Обоснованная остановка может быть правильным профессиональным решением."
   },
   {
    "id": "FAQ-9",
    "q": "Сертификат даёт ветеринарную квалификацию?",
    "a": "Нет. Он описывает только пройденный курс и оценивание."
   },
   {
    "id": "FAQ-10",
    "q": "Могут владельцы выполнять весь протокол мастера?",
    "a": "Владельцы выполняют только индивидуально назначенные и показанные домашние шаги."
   },
   {
    "id": "FAQ-11",
    "q": "Можно применять систему к кошкам?",
    "a": "Эта редакция посвящена собакам. Для кошек нужна отдельная программа."
   },
   {
    "id": "FAQ-12",
    "q": "Доказывают ли случаи причинную эффективность?",
    "a": "Одни наблюдения случая не устанавливают причину; необходимо показывать сопутствующие изменения и пропуски."
   }
  ]
 },
 "b4": {
  "legal": "Проект — не утверждён для публичного запуска"
 }
};

export default { en, ru };
